import React, { useState, useEffect } from 'react';

const ServerTest = () => {
  const [status, setStatus] = useState('Checking...');
  const [result, setResult] = useState(null);
  const [testEmail, setTestEmail] = useState({
    emailUser: '',
    emailPassword: ''
  });

  const API_BASE_URL = 'http://localhost:5000/api';

  useEffect(() => {
    // Test server connectivity
    const checkServer = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/status`);
        const data = await response.json();
        setStatus('Connected');
        setResult({
          success: true,
          message: 'Server is connected',
          details: data
        });
      } catch (error) {
        console.error('Server connection error:', error);
        setStatus('Error');
        setResult({
          success: false,
          message: 'Failed to connect to server: ' + error.message
        });
      }
    };

    checkServer();
  }, []);

  const handleDirectTest = async (e) => {
    e.preventDefault();
    
    if (!testEmail.emailUser || !testEmail.emailPassword) {
      setResult({
        success: false,
        message: 'Please enter email and password'
      });
      return;
    }
    
    try {
      const response = await fetch(`${API_BASE_URL}/update-email-config`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          emailUser: testEmail.emailUser,
          emailPassword: testEmail.emailPassword,
        }),
      });
      
      const data = await response.json();
      setResult({
        success: response.ok,
        message: response.ok ? 'Config updated' : 'Update failed',
        status: response.status,
        details: data
      });
    } catch (error) {
      console.error('Direct test error:', error);
      setResult({
        success: false,
        message: 'API call failed: ' + error.message
      });
    }
  };

  return (
    <div className="card p-4 m-3">
      <h3>Server Communication Test</h3>
      <p>Status: <strong>{status}</strong></p>
      
      {result && (
        <div className={`alert ${result.success ? 'alert-success' : 'alert-danger'}`}>
          <p><strong>Message:</strong> {result.message}</p>
          {result.status && <p><strong>Status:</strong> {result.status}</p>}
          {result.details && (
            <pre>{JSON.stringify(result.details, null, 2)}</pre>
          )}
        </div>
      )}
      
      <hr />
      
      <h4>Direct API Test</h4>
      <form onSubmit={handleDirectTest}>
        <div className="mb-3">
          <label htmlFor="emailUser" className="form-label">Email Address</label>
          <input
            type="email"
            id="emailUser"
            className="form-control"
            value={testEmail.emailUser}
            onChange={(e) => setTestEmail({...testEmail, emailUser: e.target.value})}
            required
          />
        </div>
        
        <div className="mb-3">
          <label htmlFor="emailPassword" className="form-label">App Password</label>
          <input
            type="password"
            id="emailPassword"
            className="form-control"
            value={testEmail.emailPassword}
            onChange={(e) => setTestEmail({...testEmail, emailPassword: e.target.value})}
            required
          />
        </div>
        
        <button type="submit" className="btn btn-primary">
          Test Direct API
        </button>
      </form>
    </div>
  );
};

export default ServerTest; 